// extracted by mini-css-extract-plugin
export default {"profilePage":"ProfilePage_profilePage__-9WaU","contentContainer":"ProfilePage_contentContainer__Dh3tO","link":"ProfilePage_link__RWItt"};